import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useHolidayService = () => {
    const { doGet, doPost } = useFetch();
    
    // Estados de carga
    const [fetchingGetHolidays, setFetchingGetHolidays] = useState(false);
    const [fetchingStoreHoliday, setFetchingStoreHoliday] = useState(false);
    const [fetchingShowHoliday, setFetchingShowHoliday] = useState(false);
    const [fetchingUpdateHoliday, setFetchingUpdateHoliday] = useState(false);
    const [fetchingDeleteHoliday, setFetchingDeleteHoliday] = useState(false);
    const [fetchingActiveHoliday, setFetchingActiveHoliday] = useState(false);
    const [fetchingCalculateBusinessDate, setFetchingCalculateBusinessDate] = useState(false);
    
    const BASE_PATH = 'holidays';
    
    /**
     * Obtener listado de feriados
     */
    const getHolidays = (filters: Record<string, any> = {}, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
            
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${queryString ? `?${queryString}` : ''}`),
            setFetching: setFetchingGetHolidays
        });
    };
    
    /**
     * Crear feriado
     */
    const storeHoliday = (data: Record<string, any>, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/store`),
            body: data,
            setFetching: setFetchingStoreHoliday
        });
    };
    
    /**
     * Ver feriado
     */
    const showHoliday = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/show`),
            setFetching: setFetchingShowHoliday
        });
    };
    
    /**
     * Actualizar feriado
     */
    const updateHoliday = (id: number, data: Record<string, any>, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/update`),
            body: data,
            setFetching: setFetchingUpdateHoliday
        });
    };
    
    /**
     * Eliminar feriado
     */
    const deleteHoliday = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/delete`),
            body: {},
            setFetching: setFetchingDeleteHoliday
        });
    };
    
    /**
     * Activar/Desactivar feriado
     */
    const activeHoliday = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/active`),
            body: {},
            setFetching: setFetchingActiveHoliday
        });
    };

    /**
     * Calcular fecha con días hábiles
     * @param startDate - Fecha de inicio (YYYY-MM-DD)
     * @param businessDays - Cantidad de días hábiles a sumar
     */
    const calculateBusinessDate = (startDate: string, businessDays: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/calculate-business-date`),
            body: { start_date: startDate, business_days: businessDays },
            setFetching: setFetchingCalculateBusinessDate
        });
    };
    
    return {
        // Métodos
        getHolidays,
        storeHoliday,
        showHoliday,
        updateHoliday,
        deleteHoliday,
        activeHoliday,
        calculateBusinessDate,
        // Estados de carga
        fetchingGetHolidays,
        fetchingStoreHoliday,
        fetchingShowHoliday,
        fetchingUpdateHoliday,
        fetchingDeleteHoliday,
        fetchingActiveHoliday,
        fetchingCalculateBusinessDate
    };
};

export default useHolidayService;

